import { render, staticRenderFns } from "./ordersListItem.vue?vue&type=template&id=42375ec8&"
import script from "./ordersListItem.vue?vue&type=script&lang=js&"
export * from "./ordersListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports